import _ = require("lodash");

export namespace Tools {
    export const assign = <T extends object, K extends keyof T>(...args: T[]): T =>
        args.reduce( (result, current) =>
                (Object.keys(current) as K[]).reduce((target, key) => {
                    target[key] = current[key];
                    return target;
                }, result)
            , args[0])
    ;


    /**
     * transforme un objet objet readonly
     * @param {any} obj
     * @param {Record<string, string>} rename key to new keyname
     * @return {any}
     */
    export const makeReadonlyObject = (obj, rename={}) => {
        if (_.isPlainObject(obj)){
            //c'est un objet, il faut faire pour tout membre
            let descriptor = Object.create(null);
            for(const [key, val] of Object.entries(obj))
            {
                const keyname = rename[key] || key;
                descriptor[keyname] = { value: makeReadonlyObject(val), enumerable: true };
            }

            let retObj = Object.create(null);
            Object.defineProperties(retObj, descriptor);
            return retObj;
        }
        return obj;
    }

    /**
     *
     * @param {Object|any} obj
     * @param {boolean} configurable
     * @param {Record<string, string>} rename key to new keyname
     * @return Object
     * @private
     */
    export const makeDescriptor = (obj, configurable=false, rename={}) =>
    {
        if (_.isPlainObject(obj)){
            //c'est un objet, il faut faire pour tout membre

            let descriptor = Object.create(null);
            for(const [key, val] of Object.entries(obj))
            {
                const keyname = rename[key] || key;
                descriptor[keyname] = { value: makeReadonlyObject(val), enumerable: true, configurable };
            }
            return descriptor;
        }

        return obj;
    }

    // This can live anywhere in your codebase:
    export const applyMixins = (derivedCtor: any, constructors: any[]) => {
        constructors.forEach((baseCtor) => {
            Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
                Object.defineProperty(
                    derivedCtor.prototype,
                    name,
                    Object.getOwnPropertyDescriptor(baseCtor.prototype, name) ||
                    Object.create(null)
                );
            });
        });
    }

    export const makeTemplate = (obj) =>
    {
        if (!_.isPlainObject(obj)){
            //c'est une chaine
            // @ts-ignore
            return _.template($('#'+obj).html());
        }

        let descriptor = Object.create(null);
        for(const [key, val] of Object.entries(obj))
        {
            const value = makeTemplate(val);
            descriptor[key] = { value, enumerable: true };
        }
        let value = Object.create(null);
        Object.defineProperties(value, descriptor);
        return value;
    }


    /**
     *
     * @param {string} sLibelle
     * @param {string} sActionType
     * @return string
     */
    export const sGetLettrine = (sLibelle: string, sActionType: string='') =>
    {
        const libWithoutAction = (sActionType.length ? sLibelle.replace(sActionType, '') : sLibelle).trim().replace(/-/g, ' ');
        const wordList = libWithoutAction.split(' ').map((word) => {
            return { initial: word.slice(0, 1).toUpperCase(), ln: word.length};
        });

        const firstWord = wordList.shift();
        const secondWord = wordList.sort((a, b) => {
            if (a.ln === b.ln) {
                return 0;
            }
            return a.ln > b.ln ? -1 : 1;
        }).shift();

        return firstWord.initial+ (secondWord && secondWord.ln > 0 ? secondWord.initial : '');
    }

    export const  normalizeString =(string: string) =>
    {
        if (_.isString(string)){
            return string.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        }
        return null;
    }

    export const  escapeRegExp = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
}